import * as React from 'react';
import { useAppDispatch, useExperimentByGroupName } from '../../hooks';
import { MY_HOME_REDESIGN_EXPERIMENT } from '../../constants/experiments';
import { ServiceCardsB, ServiceCardsC } from '../../components/NewServiceCards';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { openHomeProfileOnboardingModal, openNewDreamOnboardingModal } from '../../slices';
import { trackHomeProfitClick, trackNewDreamClick } from './tracking';

export const ServiceCardsContainer: React.FC = () => {
  const isDesktop = useIsDesktop();
  const dispatch = useAppDispatch();

  const isGroupNameB = useExperimentByGroupName(MY_HOME_REDESIGN_EXPERIMENT, 'B');

  const Component = isGroupNameB ? ServiceCardsB : ServiceCardsC;

  const handleNewDreamClick = React.useCallback(() => {
    dispatch(openNewDreamOnboardingModal(true));
    trackNewDreamClick();
  }, [dispatch]);

  const handleHomeProfitClick = React.useCallback(() => {
    dispatch(openHomeProfileOnboardingModal(true));
    trackHomeProfitClick();
  }, [dispatch]);

  return (
    <Component isDesktop={isDesktop} newDreamOnClick={handleNewDreamClick} homeProfitOnClick={handleHomeProfitClick} />
  );
};
